module.exports = __webpack_public_path__ + "img/justicia.d85ae91d.png";